(function () {
    class ToggleOrdersModalComponent {
        constructor(
            $scope,
            $uibModalInstance,
            name,
            state
        ) {
            this.$scope = $scope;
            this.$uibModalInstance = $uibModalInstance;
            this.$scope.name = name;
            this.$scope.storeIsLive = state === Dashboard.StoreState.Live;
            this.$scope.cancelToggle = () => {
                this.$uibModalInstance.close();
            };
            this.$scope.continueToggle = () => {
                this.$uibModalInstance.close(true);
            };
        }
    }

    angular
        .module("dashboard")
        .controller(
            "ToggleOrdersModalController",
            [
                "$scope",
                "$uibModalInstance",
                "name",
                "state",
                ToggleOrdersModalComponent
            ]
        );
})();
